import { render, staticRenderFns } from "./Ocean.vue?vue&type=template&id=baf4ea6a&scoped=true&lang=pug&"
import script from "./Ocean.vue?vue&type=script&lang=js&"
export * from "./Ocean.vue?vue&type=script&lang=js&"
import style0 from "./Ocean.vue?vue&type=style&index=0&id=baf4ea6a&lang=stylus&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "baf4ea6a",
  null
  
)

export default component.exports